// src/oura/components/documents/DocumentsTabs.tsx
//
// The two tabs on a business's Documents page: Client documents and Knowledge.
// Each tab is its own address (/documents, /knowledge), so an old Knowledge
// link still lands on its tab. Underlined page tabs, as on the merchant's
// Visibility (Jovi, 21 Oct).

import { useNavigate } from "react-router-dom";
import { BookOpenIcon, FolderOpenIcon } from "lucide-react";
import { PageTabs, type PageTab } from "@oura/ui";
import { ouraHref } from "../../nav";

type DocumentsTab = "documents" | "knowledge";

const ITEMS: PageTab<DocumentsTab>[] = [
    { key: "documents", label: "Client documents", icon: FolderOpenIcon },
    { key: "knowledge", label: "Knowledge", icon: BookOpenIcon },
];

export function DocumentsTabs({ businessId, value }: { businessId: string; value: DocumentsTab }) {
    const navigate = useNavigate();
    return (
        <PageTabs
            label="Documents"
            items={ITEMS}
            value={value}
            onOpen={(key) => navigate(ouraHref(key, { role: "oura-staff", businessId }))}
        />
    );
}
